<template>
  <div
    class="tab-pane fade"
    id="sum-gender-content"
    role="tabpanel"
    aria-labelledby="sum-gender-content-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">遊客中心</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option
              v-for="(list, index) in peopleAnalysisScenicArea"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <!-- <div class="col-md-3">
          <label for="inputEmail4" class="form-label">種類</label>
          <select class="form-control" id="SensorSN" name="SensorSN" v-model.number="selectType" disabled>
                      <option v-for="(type, index) in typeList" :key="index" :value="type.type">{{type.description}}</option>
                    </select>
        </div> -->

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="startTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料查詢時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="endTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="queryElk"
            :disabled="isWaitResult"
          >
            <i class="fas fa-search"></i> 查詢
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
            @click="queryCSV"
            :disabled="isWaitResult"
          >
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px">性別統計</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">
              <table
                id="sumGenderTable"
                class="w3-table-all table table-hover table-striped"
              >
                <thead class="table-dark">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">景區</th>

                    <th scope="col">男性</th>
                    <th scope="col">女性</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, key) in peopleAnalysisDataList"
                    :key="key"
                    :class="tableCenterStyle"
                  >
                    <td>{{ key + 1 }}</td>
                    <td style="white-space: pre-line">{{ item.time }}</td>
                    <!-- style讓 \n可以換行-->
                    <td>{{ item.scenicAreaName }}</td>
                    <td>{{ item.manCount }} / {{ item.manRatio }} %</td>
                    <td>{{ item.womanCount }} / {{ item.womanRatio }} %</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2 pt-4">
          <div style=" max-width: 300px; min-width: 250px;" class="m-auto">
          <div id="sumGenderChart" class="" >
            <apexchart
              type="donut"
              height="auto"
              :options="displaySetting"
              :series="chartData"
              
            ></apexchart>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";
import ApexchartObject from "../../utils/apexchartObject/searchPeopleAttribute";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectType: 1,
      typeList: [
        { description: "性別", type: CONST.PEOPLE_ATTRIBUTE_TYPE.GENDER },
      ],
      peopleAnalysisDataList: [],

      chartData: [0, 0],
      displaySetting: ApexchartObject.sumGenderOption,
      chartSetting: ApexchartObject.sumGenderOption,
      chartZeroSetting: ApexchartObject.sumGenderZeroOption,

      isWaitResult: false,
      maxSelectTime: moment().startOf('m').toISOString(),

    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment().startOf("m").toISOString();
    // },
    // ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


    peopleAnalysisScenicArea() {
      return this.scenicAreaList.filter(
        (s) =>
          s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE
      );
    },

    searchTime() {
      return `${moment(this.startTime).format("YYYY/MM/DD HH:mm")}~${moment(
        this.endTime
      ).format("YYYY/MM/DD HH:mm")}`;
    },

    searchAreaName() {
      const area = this.scenicAreaList.find(
        (s) => s.id === this.selectScenicAreaId
      );
      return area ? area.name : "";
    },
  },
  methods: {
    async queryCSV() {
      this.isWaitResult = true;
      const peopleAnalysisDataList = await this.searchData();
      if (Utils.isEmptyObject(peopleAnalysisDataList)) {
        return;
      }

      const csvContent = [["時間", "時間", "男性", "女性"]];
      peopleAnalysisDataList.forEach((item) => {
        const row = [];
        row.push(item.time.replace(/\n/g, ""));
        row.push(item.scenicAreaName);
        row.push(`${item.manCount} / ${item.manRatio}%`);
        row.push(`${item.womanCount} / ${item.womanRatio}%`);

        csvContent.push(row);
      });

      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_遊客統計性別.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
      this.isWaitResult = false;
    },

    async queryElk() {
      this.isWaitResult = true;
      this.peopleAnalysisDataList = await this.searchData();
      this.setChartData(this.peopleAnalysisDataList);
      this.updateTable();
      this.isWaitResult = false;
    },

    async searchData() {
      // if( this.selectScenicAreaId === -1 ) {
      //   alert('請選擇遊客中心')
      //   return
      // }

      if (Utils.isEmptyObject(this.startTime)) {
        alert("請選擇開始時間");
        return;
      }

      if (Utils.isEmptyObject(this.endTime)) {
        alert("請選擇結束時間");
        return;
      }

      const st = moment(this.startTime).startOf('minute').valueOf();
      const et = moment(this.endTime).startOf('minute').valueOf();

      const condition = {
        startTime: st,
        endTime: et,
        scenicAreaId: this.selectScenicAreaId,
        type: this.selectType,
      };

      if (this.selectScenicAreaId > -1) {
        condition.scenicAreaId = this.selectScenicAreaId;
      }

      if(this.selectScenicAreaId === -1){

        const areaId=  this.peopleAnalysisScenicArea.map((s) => s.id);
        // console.log("area",areaId)
        condition.scenicAreaId = areaId;
          // console.log("condition.areas",condition.areas);
          }

        if(this.selectScenicAreaId > -1) {
        condition.scenicAreaId= this.selectScenicAreaId
        }

      await this.$store.dispatch(
        "peopleAttribute/getPeopleAttributeListPerHour",
        condition
      );
      const result =
        this.$store.getters["peopleAttribute/getSearchGenderPerHour"];

      const total = {
        time: "統計",
        scenicAreaName: "",
        manCount: 0,
        manRatio: 0,
        womanCount: 0,
        womanRatio: 0,
      };

      const dataList = result.map((e) => {
        e.time = `${moment(e.startTime).format("YYYY-MM-DD")} \n ${moment(
          e.startTime
        ).format("HH")}~${moment(e.startTime).add(1, "h").format("HH")}`;

        total.manCount = total.manCount + e.manCount;
        total.womanCount = total.womanCount + e.womanCount;

        return e;
      });

      const totalManWoman = total.manCount + total.womanCount;
      if (totalManWoman === 0) {
        total.manRatio = 0;
        total.womanRatio = 0;
      } else {
        total.manRatio = Math.round((total.manCount / totalManWoman) * 100);
        total.womanRatio = Math.round((total.womanCount / totalManWoman) * 100);
      }

      dataList.push(total);
      return dataList;
    },

    setChartData(dataList) {
      // console.log(dataList);
      if (this.selectScenicAreaId > -1) {
        this.chartSetting.chart.toolbar.export.svg.filename = `${Utils.getSingleScenicAreaNamebyId(
          this.selectScenicAreaId
        )}_遊客性別_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
        this.chartSetting.chart.toolbar.export.csv.filename = `${Utils.getSingleScenicAreaNamebyId(
          this.selectScenicAreaId
        )}_遊客性別_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
        this.chartSetting.chart.toolbar.export.png.filename = `${Utils.getSingleScenicAreaNamebyId(
          this.selectScenicAreaId
        )}_遊客性別_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
      } else {
        this.chartSetting.chart.toolbar.export.svg.filename = `全景區_遊客性別_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartSetting.chart.toolbar.export.csv.filename = `全景區_遊客性別_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartSetting.chart.toolbar.export.png.filename = `全景區_遊客性別_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
      }

      dataList = dataList.filter((data) => data.time !== "統計"); //移除最後一位的統計欄位

      this.chartData = [];
      const initValue = 0;
      const manCount = dataList.reduce((result, current, index) => {
        result = result + current.manCount;
        return result;
      }, initValue);

      const womanCount = dataList.reduce((result, current, index) => {
        result = result + current.womanCount;
        return result;
      }, initValue);

     
      // console.log(this.chartSetting.plotOptions);

      let chartSetting = {  };
      if (manCount === 0 && womanCount === 0) {
        this.chartData = [20, 20];
        this.chartZeroSetting.plotOptions.pie.donut.labels.total.formatter =
          function (val) {
            return "0";
          };
        this.chartZeroSetting.plotOptions.pie.donut.labels.value.formatter =
          function (val) {
            return "0";
          };

          // this.chartSetting.dataLabels.enabled = true;
          this.chartZeroSetting.dataLabels.formatter = function (value, { seriesIndex, dataPointIndex, w }) {
            return  "0 %";
          };

        this.chartZeroSetting.tooltip.y.formatter = function (val) {
          return "0 人";
        };

        this.chartZeroSetting.events = null;
        chartSetting = { ...this.chartZeroSetting };
      } else {
        this.chartData = [manCount, womanCount];

        this.chartSetting.tooltip.y.formatter = function (val) {
          return val+ " 人";
        };
        chartSetting = { ...this.chartSetting };
      }

      this.displaySetting = { ...chartSetting }; // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.startTime)) {
        return "-";
      }

      const time = moment(item.startTime);
      return `${time.format("YYYY/MM/DD")}`;
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    initTable: function () {
      this.table = $("#sumGenderTable").DataTable({
        aoColumns: [
          ...new Array($("#sumGenderTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 32,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  mounted() {
    this.updateTable();
  },
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
} /* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
} /* table不超過div */
</style>
